// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;

// @ commons
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardError = require('components/commons/wizardError/wizardError');

// @ constants
const { PROC_ACTIVATE_CARD } = require('utilities/tagging');

class CardActivationR42Error extends React.Component {

    render() {
        const { immCard } = this.props;
        const errorTitle = formatText('cardActivationR42-cardActivationR42_errorTitle');
        const goBackButtonLabel = formatText('cardActivate-errorBackToCards');
        const linkToDetails = '/myprofile/cards';
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToDetails,
        };

        return (
            <article className="col-xs-10 col-xs-offset-1">
                <WizardError
                    errorMessage={errorTitle}
                    mainButton={goBackButton}
                    processType={PROC_ACTIVATE_CARD}
                >
                    <section className="row no-gutter">
                        <div className="col-xs-5">
                            <CommercialAds
                                immCard={immCard}
                                path="cards"
                                size="medium"
                                type="cards"
                            />
                        </div>
                    </section>
                </WizardError>
            </article>
        );
    }
}

CardActivationR42Error.propTypes = {
    immCard: PropTypes.object.isRequired,
};

module.exports = CardActivationR42Error;
